import React, { useState, useEffect } from "react";
import "../Eligibility/Eligibility.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CharIcon from "../../Assets/img/word.png";
import API from "../Service/Baseservice";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Loading from "../../Loading/loading";
import EligibilityPreview from "./EligibilityPreview";
const eligibilityMap = {
    1: 2, // English
    2: 4  // French
};
const EligibilityEdit = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const lang = queryParams.get("lang");

    const languageId = Number(lang) || 1;
    const [showPreviewEligibility, setShowPreviewEligibility] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [checkId, setCheckId] = useState(null);

    const [data, setData] = useState({
        title: "",
        heading: "",
        description: "",
    });

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html || "";
        return div.textContent?.length || 0;
    };

    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "",
    });

    // Fetch data
    const fetchData = () => {
        setLoading(true);

        API.post("checkeligibility_listview/condition", {
            eligibility_id: id,
            language_id: languageId,
        })
            .then((res) => {
                const details = res?.data?.data?.eligibilityData?.[0];

                if (details) {
                    setCheckId(details.check_eligibility_id);

                    setData({
                        title: details.title || "",
                        heading: details.heading || "",
                        description: details.description || "",
                    });
                }
            })
            .catch((err) => console.error("Fetch error:", err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    // SAVE handler
    const handleSave = () => {
        if (!checkId) {
            alert("Missing check_eligibility_id");
            return;
        }

        const payload = {
            check_eligibility_id: checkId,
            language_id: languageId,
            eligibility_id: Number(id),
            title: data.title,
            heading: data.heading,
            description: data.description,
            active: 1,
            updatedBy: 1,
        };

        API.post("edit_eligibility/update", payload)
            .then(() => {
                setPopup({
                    show: true,
                    title: "Updated Successfully",
                    message: "Eligibility details updated successfully.",
                    type: "success",
                });
            })
            .catch(() => {
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to update eligibility.",
                    type: "error",
                });
            });
    };
    const handlePreview = () => {

        // BASIC VALIDATION
        if (!data.heading.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Heading is required for preview!",
                type: "info",
            });
        }

        if (!data.title.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Title is required for preview!",
                type: "info",
            });
        }

        if (!data.description.trim()) {
            return setPopup({
                show: true,
                title: "Required",
                message: "Description is required for preview!",
                type: "info",
            });
        }

        // SET PREVIEW DATA
        setPreviewData({
            title: data.title,
            heading: data.heading,
            description: data.description,
        });

        setShowPreviewEligibility(true);
    };

    return (
        <div className="newss-containeradd">

            {/* Header */}
            <div className="edit-eligibility-header-bar">
                <h2 className="services-title1">Edit Eligibility</h2>

                <div className="header-right">
                    <div className="filter-block">
                        <label>Language</label>
                        <div className="input-container">
                            <select
                                value={languageId}
                                className="input-field"
                                onChange={(e) => {
                                    const newLang = Number(e.target.value);
                                    const newEligibilityId = eligibilityMap[newLang];

                                    navigate(`/eligibilityedit/${newEligibilityId}?lang=${newLang}`);
                                }}
                            >
                                <option value={1}>English</option>
                                <option value={2}>Français</option>
                            </select>
                        </div>
                    </div>
                    <button onClick={handlePreview} className="language-save-btn">
                        Preview
                    </button>
                    <button className="language-save-btn" onClick={handleSave}>
                        Save
                    </button>
                    <button className="language-save-btn" onClick={() => navigate("/eligibility")}>
                        Back
                    </button>
                </div>
            </div>

            {loading ? (
                <Loading />
            ) : (
                <>
                    <div className="edit-eligibility-container">

                        {/* LEFT SECTION */}
                        <div className="left-form">

                            {/* Title */}
                            <div className="form-group">
                                <label>Title <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={data.title}
                                    maxLength={70}
                                    onChange={(e) =>
                                        setData({ ...data, title: e.target.value })
                                    }
                                    placeholder="Enter your text here..."
                                />
                            </div>

                            {/* Heading */}
                            <div className="form-group">
                                <label>Heading <span className="required">*</span></label>
                                <input
                                    type="text"
                                    value={data.heading}
                                    maxLength={150}
                                    onChange={(e) =>
                                        setData({ ...data, heading: e.target.value })
                                    }
                                    placeholder="Enter your text here..."
                                />
                            </div>

                            {/* Description */}
                            <div className="form-group">
                                <label className="description-label" style={{ marginBottom: "16px" }}>
                                    <span className="label-text">
                                        Description <span className="required">*</span>
                                    </span>
                                    <div className="char-wrapper">
                                        <img src={CharIcon} alt="Character count" />
                                        <span className="char-count">
                                            {getPlainTextLength(data.description)}/4000
                                        </span>
                                    </div>
                                </label>

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={data.description}
                                    onReady={(editor) => {
                                        // Prevent typing beyond 4000 characters
                                        editor.editing.view.document.on("keydown", (evt, data) => {
                                            const div = document.createElement("div");
                                            div.innerHTML = editor.getData();
                                            const textLength = div.textContent?.length || 0;

                                            if (
                                                textLength >= 4000 &&
                                                !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(data.key)
                                            ) {
                                                data.preventDefault();
                                                evt.stop();
                                            }
                                        });
                                    }}
                                    onChange={(evt, editor) => {
                                        const html = editor.getData();
                                        const div = document.createElement("div");
                                        div.innerHTML = html;
                                        const textLength = div.textContent?.length || 0;

                                        if (textLength <= 4000) {
                                            setData({ ...data, description: html });
                                        } else {
                                            // Revert to last valid value if over limit
                                            editor.setData(data.description);
                                        }
                                    }}
                                    config={{
                                        toolbar: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "heading",
                                            "|",
                                            "bold",
                                            "italic",
                                            "underline",
                                            "|",
                                            "bulletedList",
                                            "numberedList",
                                        ],
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* POPUP */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <button
                            className="btn ok-btn"
                            onClick={() => {
                                setPopup({ ...popup, show: false });

                                if (popup.type === "success") {
                                    navigate("/eligibility");
                                }
                            }}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
            {showPreviewEligibility && (
                <EligibilityPreview
                    previewService={previewData}
                    setShowPreviewEligibility={setShowPreviewEligibility}
                />
            )}
        </div>
    );
};

export default EligibilityEdit;
